/**
 * AI dataset create stores the full snapshot in meta.generation_config (see finetune_dataset.meta JSONB).
 * Top-level meta may only duplicate a few keys; merge so UI and review read all generation fields.
 */
export function mergeDatasetGenerateMeta(
  meta: Record<string, unknown> | null | undefined
): Record<string, unknown> {
  const m = meta && typeof meta === "object" && !Array.isArray(meta) ? { ...meta } : {};
  const cfg = m.generation_config;
  if (!cfg || typeof cfg !== "object" || cfg === null || Array.isArray(cfg)) {
    return m;
  }
  const c = cfg as Record<string, unknown>;
  return { ...c, ...m };
}
